// Carried over from StreamVault V1 — no changes to economy numbers

let _cachedThresholds = null;
export const getLevelThresholds = () => {
  if (_cachedThresholds) return _cachedThresholds;

  const thresholds = [0];
  let currentXp = 0;

  currentXp += 100;  thresholds.push(currentXp);
  currentXp += 250;  thresholds.push(currentXp);
  currentXp += 400;  thresholds.push(currentXp);

  for (let i = 4; i <= 18; i++) {
    currentXp += 150;
    thresholds.push(currentXp);
  }

  for (let i = 19; i <= 1000; i++) {
    currentXp += 648;
    thresholds.push(currentXp);
  }

  _cachedThresholds = thresholds;
  return thresholds;
};

export const getUserLevel = (totalXp) => {
  const thresholds = getLevelThresholds();
  let level = 1;
  for (let i = 1; i < thresholds.length; i++) {
    if (totalXp >= thresholds[i]) level = i + 1;
    else break;
  }
  return Math.min(level, 1000);
};

export const getXpForNextLevel = (totalXp) => {
  const thresholds = getLevelThresholds();
  const level = getUserLevel(totalXp);
  if (level >= 1000) return 0;
  return thresholds[level] - totalXp;
};

export const getXpProgress = (totalXp) => {
  const thresholds = getLevelThresholds();
  const level = getUserLevel(totalXp);
  if (level >= 1000) return 100;
  const currentThreshold = thresholds[level - 1];
  const nextThreshold = thresholds[level];
  return Math.round(((totalXp - currentThreshold) / (nextThreshold - currentThreshold)) * 100);
};

export const getXpGain = (source, dayInBonus = null) => {
  if (source === 'daily-bonus') {
    return dayInBonus <= 17
      ? Math.floor(Math.random() * 35) + 4
      : Math.floor(Math.random() * 72) + 15;
  }
  // slot-machine, chest
  return Math.floor(Math.random() * 35) + 4;
};
